<template>
  <div class="common-actions d-flex">
    <qtm-btn secondary target="_blank" :to="{ name: 'orders-id', params: { id: order.id } }">
      Order
    </qtm-btn>
    <div v-if="order.quotes && order.quotes.length">
      <quotes-received-summary :quotes="order.quotes" />
    </div>

    <div v-if="order.hasPurchaseOrderLinks">
      <purchase-order-links
        v-for="poLink in order.purchaseOrderLinks"
        :id="poLink.link.params.id"
        :key="poLink.link.params.id"
        :number="poLink.label || undefined"
        :order="order"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Order } from '@quotetome/materials-api'
import PurchaseOrderLinks from '@/components/admin/actions/purchase-order-links.vue'
import QuotesReceivedSummary from '@/components/admin/actions/quotes-received-summary.vue'

export interface Props {
  order: Order
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.common-actions > *:not(:last-child) {
  margin-right: 0.5rem;
}
</style>
